'use strict';

(function () {
  'use strict';

  angular.module('zp').service('LoaderService', loaderService);

  function loaderService($q, $rootScope) {
    var service = this;

    service.start = start;
    service.stop = stop;

    /////////////////////////////////////

    function start() {
      return $q.when(function () {
        $rootScope.showLoader = true;
      }());
    }

    function stop() {
      return $q.when(function () {
        $rootScope.showLoader = false;
      }());
    }
  }
})();